import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericUtilityService } from 'src/app/generic/generic-utility.service';
import { environment } from 'src/environments/environment';
const baseApiOCR = environment.baseAPIOCR;
@Injectable({
  providedIn: 'root'
})
export class InsurancePhase2Service {

  progress$: any;
  private progressObserver: any;
  private progress: any;
  
  constructor(private GenericUtility: GenericUtilityService) { }
  SearchPatientInsurance(searchinsurancemodel: any) {
    return this.GenericUtility.ApiPostMethodTalkphr("TalkCheckinPhaseTwo", "SearchPatientInsurance", searchinsurancemodel);
  }
  GetPatientInsuranceInfo(patientAccount: any, practiceCode: any, AppointmentId: any) {
    const apptID = '0';
    return this.GenericUtility.ApiGetMethodTalkphr("TalkCheckinPhaseTwo/GetPatientInsuranceInfo?PracticeCode=" + practiceCode + '&PatientAccount=' + patientAccount + '&AppointmentId=' + apptID);
  }
  UpdatePatientInsurance(updateinsurancemodel: any) {
    return this.GenericUtility.ApiPostMethodTalkphr("TalkCheckinPhaseTwo", "UpdatePatientInsurance", updateinsurancemodel);
  }
  AddPatientInsurance(addinsurancemodel: any) {
    return this.GenericUtility.ApiPostMethodTalkphr("TalkCheckinPhaseTwo", "AddPatientInsurance", addinsurancemodel);
  }
  async AddSubscriber(_updatesubscriberinfo: any) {
    return await this.GenericUtility.ApiPostMethodTalkphr("TalkCheckinPhaseTwo", "AddUpdateSubscriber", _updatesubscriberinfo).toPromise();
  }
  GetSubscriberDetails(practiceCode: any, patientAccount: any, GuarantorCode: any) {
    return this.GenericUtility.ApiGetMethodTalkphr("TalkCheckinPhaseTwo/GetSubscriberDetails?PracticeCode=" + practiceCode + '&PatientAccount=' + patientAccount + '&GuarantorCode=' + GuarantorCode);
  }
  uploadAtFolder(files: File, folder: any, PATIENT_ACCOUNT: any, PRACTICE_CODE: any, ImageSubType: any) {

    return this.makeFileRequest(files, folder, PATIENT_ACCOUNT, PRACTICE_CODE, ImageSubType);
  }
  private makeFileRequest(files: File, folder: any, PATIENT_ACCOUNT: any, PRACTICE_CODE: any, ImageSubType: any): Observable<any> {
    return Observable.create((observer: any) => {
      let formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };
      xhr.upload.onprogress = (event) => {
        this.progress = Math.round(event.loaded / event.total * 100);
        if (this.progressObserver)
          this.progressObserver.next(this.progress);
      };
      xhr.open('POST', this.GenericUtility.getBaseIpTalkPhr() + folder, true);
      // for (let i = 0; i < files.length; i++) {
      formData.append("PatientAccount", PATIENT_ACCOUNT);
      formData.append("PracticeCode", PRACTICE_CODE);
      formData.append("image", files);
      formData.append("ImageSubType", ImageSubType);
      //formData.append("uploads", files[i].name);
      //formData.append("size", files[i], files[i].size.toString());
      //formData.append("type", files[i], files[i].type);
      // }
      //add JWT token for save profile pic
      xhr.setRequestHeader('Authorization', "Bearer " + localStorage.getItem("AuthTokenwebServices"));
      xhr.send(formData);
    });
  }
  OcrInsurance(files:any)
  {
    
    return Observable.create((observer:any) => {
      
      let formData: FormData = new FormData(),
      xhr: XMLHttpRequest = new XMLHttpRequest();
      
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };
      
      xhr.upload.onprogress = (event) => {
        this.progress = Math.round(event.loaded / event.total * 100);
        if (this.progressObserver)
        this.progressObserver.next(this.progress);
      };
      
      
      xhr.open('POST', baseApiOCR, true);
      
      
      if(files == null){
        formData.append("file[]" , "");
      } else {
        let i=0;
        Array.from(files).forEach((file:any) => 
        {
          if(file.type.includes("png"))
          formData.append('file[]', file,'ocr'+i+'.png');
          else
          if(file.type.includes("jpg"))
          formData.append('file[]', file,'ocr'+i+'.jpg');
          else
          if(file.type.includes("jpeg"))
          formData.append('file[]', file,'ocr'+i+'.jpeg');
          //else
          // if(file.type.includes("jpg"))
          // formData.append('file[]', file,'ocr'+i+'.jpg');
          // else
          // if(file.type.includes("jpg"))
          // formData.append('file[]', file,'ocr'+i+'.jpg');
          i++;
        });
        
      }
      xhr.send(formData);
    });
  }
  DeletePatientInsurance(data:any)
  {
    return this.GenericUtility.ApiPostMethodTalkphr("TalkCheckinPhaseTwo","DeletePatientInsurance",data);
  }
  GetIsSelfPayOrInsurance(patient_account:any,practice_code:any)
  {
    return this.GenericUtility.ApiGetMethodTalkphr("TalkCheckinPhaseTwo/GetPatientInsuranceData?PatientAccount="+patient_account+"&PracticeCode="+practice_code);
  }
  UpdatePatientSelfPayBit(data:any)
  {
    return this.GenericUtility.ApiPostMethodTalkphr("TalkCheckinPhaseTwo","UpdatePatientSelfPayBit",data);
  }
}
